import React, { useState, useContext, useEffect } from 'react'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import ReactPlayer from 'react-player/lazy'
import CustomDialog from '@/product/components/organisms/Dialog'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { Button } from '@material-ui/core'
import UserContext from '@/product/context/user/userContext'
import { useMediaQuery } from 'react-responsive'
import AuthContext from '../../../../product/context/auth/authContext'

const VideoPlayerModel = (props) => {
    const userContext = useContext(UserContext)
    const {
        updateProfile,
        responseStatus: responseStatusProfile,
        clearResponse: clearResponseProfile,
    } = userContext
    const [checked, setChecked] = useState(false)
    const authContext = useContext(AuthContext)

    const { loadUser } = authContext
    const isTablet = useMediaQuery({ query: '(min-width: 430px) and (max-width: 540px)' })
    const isMobile = useMediaQuery({ query: '(max-width: 430px)' })

    const settings = {
        dots: false,
        arrows: true,
        fade: true,
        infinite: true,
        slidesToShow: 1, // Show 1 slide at a time
        slidesToScroll: 1, // Scroll 1 slide at a time
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 6000,
        cssEase: 'linear',
    }

    const proceedUpdateProfileApi = (params) => {
        updateProfile(params, false, 'update-profile-alert')
    }

    const toggleFavourite = () => {
        if (checked) {
            if (props?.offerPage) {
                proceedUpdateProfileApi({
                    offer_dont_show: true,
                })
            } else if (props?.savedSearchPage) {
                proceedUpdateProfileApi({
                    saved_search_dont_show: true,
                })
            } else if (props.profilePage) {
                proceedUpdateProfileApi({
                    profile_dont_show: true,
                })
            }
        } else {
            props?.changeDialogStatus()
        }
    }

    const toggleCheked = () => {
        setChecked(!checked)
    }

    useEffect(() => {
        if (responseStatusProfile) {
            if (responseStatusProfile.from === 'update-profile-alert') {
                if (responseStatusProfile.status === 'success') {
                    props?.changeDialogStatus()
                    loadUser()
                }
            }

            // clearResponseProfile()
        }
    }, [responseStatusProfile])

    return (
        <>
            <CustomDialog
                title={props?.title}
                open={props?.toggleDialog}
                className={`customvideoplayer ${props?.class}`}
                function={props?.changeDialogStatus}
                disableBackdropClick
                handleClose={props?.changeDialogStatus}
            >
                {props?.url?.length > 1 ? (
                    <Slider {...settings}>
                        {props?.url?.map((image, index) => {
                            return (
                                <div key={index}>
                                    <ReactPlayer
                                        className="react-player"
                                        width="100%"
                                        height={isTablet ? '200px' : isMobile ? '160px' : '435px'}
                                        url={image}
                                        playing
                                        stopOnUnmount={false}
                                        muted={false} // Unmute the video
                                        controls
                                        playsinline
                                        pip
                                    />
                                </div>
                            )
                        })}
                    </Slider>
                ) : (
                    <>
                        <ReactPlayer
                            className="react-player"
                            width="100%"
                            height={isTablet ? '200px' : isMobile ? '160px' : '435px'}
                            url={props?.url[0]}
                            playing
                            stopOnUnmount={false}
                            muted={false} // Unmute the video
                            controls
                            playsinline
                            pip
                        />
                    </>
                )}

                {props.infolable ? null : (
                    <div className="videoActionWrapper">
                        <div className="checkbox-container">
                            <input
                                id="video-check"
                                className="video-check"
                                type="checkbox"
                                checked={checked}
                                onChange={toggleCheked}
                            />
                            <label htmlFor="video-check" className="ml-2">
                                {"Don't show again"}
                            </label>
                        </div>

                        <SecondaryButton
                            label={'Close'}
                            btnSize={'small'}
                            className={isTablet ? 'ml-2' : 'ml-4'}
                            onClick={toggleFavourite}
                        />
                    </div>
                )}
            </CustomDialog>
        </>
    )
}

export default VideoPlayerModel
